import { Controller } from "@hotwired/stimulus"

// Small launcher modal for the dashboard "AI Interview" card. Showcases
// Interview Buddy + AI Mock Interview and routes by plan: the Mock Interview
// "Upgrade" CTA (standard users only) pops the global app-upgrade-modal.
export default class extends Controller {
  connect() {
    // Portal to <body> so the dashboard's stacking context can't trap the overlay.
    if (this.element.parentElement !== document.body) document.body.appendChild(this.element)
    this._open = (e) => { if (e && e.preventDefault) e.preventDefault(); this.open() }
    this._onKey = (e) => { if (e.key === "Escape") this.close() }
    document.querySelectorAll("[data-interview-launcher-open]").forEach((b) => b.addEventListener("click", this._open))
  }

  disconnect() {
    document.querySelectorAll("[data-interview-launcher-open]").forEach((b) => b.removeEventListener("click", this._open))
    document.removeEventListener("keydown", this._onKey)
  }

  open() {
    this.element.classList.remove("hidden")
    this.element.classList.add("flex")
    document.addEventListener("keydown", this._onKey)
    this.element.querySelector("[data-il-close]")?.focus()
  }

  close() {
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    document.removeEventListener("keydown", this._onKey)
  }

  backdrop(e) { if (e.target === this.element) this.close() }
  stop(e) { e.stopPropagation() }

  // Standard users: close this modal and pop the global upgrade modal (mounted
  // in the app shell for non-premium users). Fall back to direct checkout.
  upgrade() {
    this.close()
    if (document.getElementById("app-upgrade-modal")) {
      window.dispatchEvent(new CustomEvent("app-upgrade-modal:open"))
    } else {
      window.location = "/users/premium_subscribe_direct"
    }
  }
}
